// extracted by mini-css-extract-plugin
export var active = "slider-dot-module--active--G0jXS";
export var sliderDot = "slider-dot-module--slider-dot--hvGeo";